export default "__VITE_ASSET__IStw4mAS__"